import {Elements, PaymentElement, useElements, useStripe} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import {useEffect, useState} from "react";
import {Modal} from "./Modal.tsx";

const appearance = {
  theme: 'night',
  labels: 'floating',

  variables: {
    colorPrimary: '#EFC904',
    colorBackground: '#161C27',
    colorText: '#DEDDD7',
    colorDanger: '#F92727',
    fontFamily: 'Ideal Sans, system-ui, sans-serif',
    spacingUnit: '2px',
    borderRadius: '4px',
    // See all possible variables below
  }
};

function CheckoutForm({onAbort, course, amount}) {
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    const result = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.origin+"/redirect"+window.location.search+"&course="+course,
      },
    });

    if (result.error) {
      console.log(result.error.message);
    } else {
    }
  };

  return (
    <Modal actionP={handleSubmit} actionS={onAbort} buttonS={"Abbrechen"} buttonP={"Zahlen"} valid={stripe !== null} header={`Zahlung über ${amount}€`}>
      <form onSubmit={handleSubmit}>
        <PaymentElement/>
      </form>
    </Modal>
  );

}

export default function StripeCheckout({intent, onAbort, course}) {
  const [stripePromise, setStripePromise] = useState(null)
  const options = {
    // passing the client secret obtained from the server
    clientSecret: intent.clientSecret,
    appearance,
    layout: {
      type: 'tabs',
      defaultCollapsed: false,
    }
  };

  useEffect(() => {
    setStripePromise(loadStripe(intent.info))
  }, [])

  return (
      <Elements stripe={stripePromise} options={options}>
        <CheckoutForm onAbort={onAbort} course={course} amount={intent.amount}/>
      </Elements>
  );
};